module.exports = __webpack_public_path__ + "img/1513871627.00e2adf1.jpg";